import React, { Component } from 'react';
import Hex from './Hex';
import Dec from './Dec';
import Bin from './Bin';
//import{PI,PF,PC1,PC2,rotations,S,E,P} from "./DESConstants"
import styled from "styled-components";
//import "bootstrap/dist/css/bootstrap.min.css"


class Converter extends Component {
  constructor(props){
    super(props);
    this.state={
      bintodec: "",
      bintohex: "",
      hextodec:"",
      hextobin: "",
      dectohex:"",
      dectobin: "",
      touched: {
        binInput:false,
        hexInput: false,
        decInput: false

      },
      selected: ""
    }
  }
  /* je veux modifier l'input quand c'est un caracter non admis*/
  cuttingLetter = (text,name)=>{
      if(name==="hexInput"){
        if(/[g-zG-Z\W]/.test(text)){
          if(text.length===1)return text.slice(1)
          if(text.length>1){
            return text.slice(0,text.length-1)
          }
        }
      }
      if(name==="decInput"){
        if(/[a-zA-Z\W]/.test(text)){
          if(text.length===1)return text.slice(1)
          if(text.length>1){
            return text.slice(0,text.length-1)
          }
        }
      } 
      if(name==="binInput"){
        if(/[a-zA-Z2-9\W]/.test(text)){
          if(text.length===1)return text.slice(1)
          if(text.length>1){
            return text.slice(0,text.length-1)
          }
        }
      }  
    return text;
  }
  toBit=(chaineDeCaractere)=>{
    chaineDeCaractere = chaineDeCaractere.split("");
    let asciiTable = chaineDeCaractere.forEach(caract=>this.toAscii(caract));
    let arrayOfbit = asciiTable.forEach(dec=>this.decToBin(dec));
    return arrayOfbit.join("");

  }
  toAscii=(entry)=>{
    let tableAscii = ["NUL","SOH","STX","ETX","EOT","ENQ","ACK","BEL","BS","HT","LF","VT","FF","CR","SO","SI","DLE","DC1","DC2","DC3","DC4","NAK","SYN","ETB","CAN","EM","SUB","ECS","FS","GS","RS","US","SP","!","\"","#","$","%","&","'","(",")","*","+",",","-",".","/","0","1","2","3","4","5","6","7","8","9",":",";","<","=",">","?","@","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","[","\\","]","^","_","`","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","{","|","}","~","DEL"];
    let asciiCharact = tableAscii.filter((c,i)=>c===entry&&i)[0];
    return asciiCharact
  }
  
  handleInput=(e)=>{
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let nv = ""
    if(name==="hexInput"){
       nv = this.cuttingLetter(value,name);
       this.setState({hexInput: nv})
    }
    else if(name==="decInput"){
      nv = this.cuttingLetter(value,name);
      this.setState({decInput: nv})
    }
    else {
      nv = this.cuttingLetter(value,name);
      this.setState({binInput: nv})
    }
  }
  viderInput=(e)=>{
    const target = e.target;
    const name = target.name;
    this.setState({
      [name] : ""
    })
  }
  /*  trouver un moyen pour vider les autres input quand l'un est actif  */ 
  onBlur=(champs)=>(e)=>this.setState({touched:{...this.state.touched,[champs]:false}})
  onFocus = (champs)=>(e)=>this.setState({touched:{...this.state.touched,[champs]:true},selected: champs,})
  exposant = (nombre,exp)=>{
    let resultat=1;
	  for(var i=0;i<exp;i++){
	  	resultat*=nombre;
    }
    return resultat;
  }
  setFrom = (name,value)=>{
        this.setState({[name]: value})
  }
  binToDec = (bin)=>{
    if (bin.length===0) return ""
     let tempTab = bin.split("").reverse()
     let resultat=0;
     for(var i=0;i<tempTab.length;i++){
       if(Number(tempTab[i])===1){
         resultat=resultat+this.exposant(2,i); 
       }
     }
     
     return resultat;
   }
  decToBin = (dec)=>{
    if(dec.length===0) return ""
    dec = Number(dec);
   let rest = []
   while(dec>=2){
     rest=[...rest,dec%2];
     dec=Math.trunc(dec/2);
   }
   if(dec<2){
     rest=[...rest,dec]
   }
   return rest.reverse().join("");
 }

  decToHex=(dec)=>{
    if(dec.length===0) return ""
    dec=Number(dec)
    let rest = [];
    let hexTab=[0,1,2,3,4,5,6,7,8,9,"A","B","C","D","E","F"]
    while(dec>=16){
      let modulo=dec%16
      for(var i=0;i<hexTab.length;i++){
        if(modulo===i){
          rest=[...rest,hexTab[modulo]]
        }
      }
      dec=Math.trunc(dec/16);
    }
    if(dec<16){
      for( i=0;i<hexTab.length;i++){
        if(dec===i){
          rest=[...rest,hexTab[i]]
        }
      }
    }
    return rest.reverse().join("")
  }
  hexToDec = (hex)=>{
    
    let tempTab=hex.toUpperCase().split("").reverse()

    let result=[];
    let hexTab=[0,1,2,3,4,5,6,7,8,9,"A","B","C","D","E","F"];
    if(tempTab.length===1){
      for(var i =0; i<hexTab.length;i++){

        if(tempTab[0]==hexTab[i]){
          return i;
        }
      } 
    }
    tempTab.forEach((element,index) => {
      for(var i =0; i<hexTab.length;i++){
        if(element==hexTab[i]){
          result=[...result,i*this.exposant(16,index)]
        }
      }
    });
    return result.length!==0 ? result.reduce((a,b)=>(a+b)):""

  }
  hexToBin = (hex)=>{
    if(hex.length===0) return ""
    let dec = this.hexToDec(hex);
    return this.decToBin(dec)
  }
  binToHex = (bin)=>{
    if(bin.length===0) return ""
    let dec = this.binToDec(bin);
    return this.decToHex(dec);
  }
  handleSelected=()=>{

  }
  render() {
    return (
      <ConverterWrapper>
         
            <label>
              <p>decimal</p>
              <Dec decInput={this.state.decInput}
                setFrom={this.setFrom}
                caracterFilter={this.cuttingLetter}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                bintodec={this.state.bintodec}
                hextodec={this.state.hextodec}
                touched={this.state.touched}
                decToBin={this.decToBin}
                decToHex={this.decToHex}/>
              </label> 
            <label>
              <p>binaire</p>         
              <Bin binInput={this.state.binInput} 
                setFrom={this.setFrom}
                caracterFilter={this.cuttingLetter}
                binToHex={this.binToHex}
                binToDec={this.binToDec}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                dectobin={this.state.dectobin}
                hextobin={this.state.hextobin}
                touched={this.state.touched}/>
            </label>  
            <label>
                <p>hexadecimal</p>          
                <Hex hexInput={this.state.hexInput} 
                setFrom={this.setFrom}
                caracterFilter={this.cuttingLetter}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                touched={this.state.touched}
                hexToBin={this.hexToBin}
                hexToDec={this.hexToDec}
                dectohex={this.state.dectohex}
                bintohex={this.state.bintohex}/>
            </label>
          
    
      </ConverterWrapper>
    );
  }
}



const ConverterWrapper =  styled.div`
    
    height: 100%;
    width: 100%;
    position: relative;
    
`

export default Converter;
